import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface SessionExpiredDialogProps {
    open: boolean;
    onClose?: () => void;
}

const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({open, onClose}) => {
    const {t} = useTranslation();

    const handleConfirm = () => {
        onClose?.();
    };

    return (
        <Dialog open={open} aria-labelledby="session-expired-title">
            <DialogTitle id="session-expired-title">{t('sessionExpiredDialog.title')}</DialogTitle>
            <DialogContent>
                <Typography>
                    {t('sessionExpiredDialog.message')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleConfirm}>
                    {t('sessionExpiredDialog.goToLogin')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiredDialog;
